import React from 'react'
import PropTypes from 'prop-types'
import { IMaskInput } from 'react-imask'
import dayjs from 'dayjs'
import 'dayjs/locale/ru' // Импортируем русскую локаль
import updateLocale from 'dayjs/plugin/updateLocale'

// Устанавливаем русскую локаль
dayjs.locale('ru')

// Расширяем dayjs плагином для обновления локали
dayjs.extend(updateLocale)

// Обновляем названия дней недели на русском
dayjs.updateLocale('ru', {
  weekdays: [
    "Воскресенье", "Понедельник", "Вторник", "Среда", 
    "Четверг", "Пятница", "Суббота"
  ]
})

import SimpleHeader from './../block/SimpleHeader'
import DeliveryType from './../block/DeliveryType'

// SVG иконки вынесены в константы
const Arrow = ({ isOpen = false }) => (
  <svg 
    width="10" 
    height="6" 
    viewBox="0 0 10 6" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
  >
    <path d="M9 5L5 1L1 5" stroke="black" strokeLinecap="round"/>
  </svg>
)

const Coin = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={20} fill="none">
    <path
      fill="#5A91FF"
      d="M8 1.9c4.418 0 8 3.627 8.001 8.1 0 4.473-3.583 8.1-8.001 8.1-4.418 0-8-3.627-8-8.1s3.582-8.1 8-8.1ZM4.728 8.413c-1.238 0-2.26.993-2.26 2.218.001 1.224 1.022 2.217 2.26 2.217a2.215 2.215 0 0 0 2.224-2.217 2.215 2.215 0 0 0-2.224-2.218ZM8.046 7.2a.685.685 0 0 0-.685.685v4.278a.685.685 0 0 0 1.37 0v-1.117l1.25 1.567a.624.624 0 0 0 .996-.75l-.947-1.337.84-1.101a.543.543 0 1 0-.866-.657L8.73 10.457V7.885a.685.685 0 0 0-.684-.685Zm4.176 1.352a.62.62 0 0 0-.617.624v3.049a.62.62 0 0 0 .617.623.62.62 0 0 0 .616-.623v-3.05a.62.62 0 0 0-.616-.623ZM4.728 9.59c.532 0 .958.465.958 1.04 0 .574-.426 1.039-.958 1.039-.533 0-.992-.464-.993-1.04 0-.574.46-1.04.993-1.04Zm8.438-3.153c-.3-.575-.724.03-.913.37-.19-.34-.627-.944-.928-.37-.301.576.478 1.398.92 1.75.443-.352 1.223-1.174.921-1.75Z"
    />
    <path
      stroke="#5A91FF"
      strokeLinecap="round"
      strokeWidth={1.8}
      d="M8 1.9V1M8 19v-.9"
    />
  </svg>
)

const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={11} fill="none">
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={2}
      d="M1 4.105 5.518 9 13 1"
    />
  </svg>
)

const TimeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21} height={21} fill="none">
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.6}
      strokeWidth={1.462}
      d="M10.5 7.08v4.078l2.046 2.046"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.6}
      strokeWidth={1.462}
      d="M1 10.5A9.5 9.5 0 0 1 10.5 1a9.5 9.5 0 0 1 9.5 9.5 9.513 9.513 0 0 1-3.654 7.498h-.015A9.416 9.416 0 0 1 10.5 20c-2.178 0-4.18-.73-5.788-1.973h-.014A9.48 9.48 0 0 1 1 10.5Z"
    />
  </svg>
)

const CardIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={17} fill="none">
    <path
      fill="#000"
      fillRule="evenodd"
      d="M.413 5.128c0-.37.3-.669.669-.669h17.837a.669.669 0 1 1 0 1.338H1.082c-.37 0-.669-.3-.669-.669ZM3.98 12.263c0-.37.3-.67.67-.67h1.783a.669.669 0 1 1 0 1.338H4.649c-.37 0-.669-.299-.669-.668ZM7.993 12.263c0-.37.3-.67.669-.67h3.567a.669.669 0 1 1 0 1.338H8.662c-.37 0-.669-.299-.669-.668Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M2.345 1.928c-.38.375-.594 1.087-.594 2.656v7.33c0 1.57.215 2.282.593 2.655.381.376 1.107.588 2.696.583h9.919c1.588 0 2.315-.213 2.697-.59.379-.375.594-1.087.594-2.656V4.584c0-1.569-.215-2.28-.595-2.655-.383-.378-1.112-.591-2.705-.591H5.042c-1.589 0-2.315.213-2.697.59Zm-.94-.951C2.21.179 3.463 0 5.041 0h9.908c1.582 0 2.837.18 3.645.976.81.8.992 2.046.992 3.608v7.322c0 1.562-.181 2.807-.99 3.607-.807.798-2.06.977-3.638.977H5.042c-1.577.004-2.83-.172-3.637-.969-.81-.799-.992-2.045-.992-3.606V4.584c0-1.562.182-2.807.991-3.607Z"
      clipRule="evenodd"
    />
  </svg>
)

const CashIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none">
    <path
      fill="#000"
      fillRule="evenodd"
      d="M3.679 5.862A2.456 2.456 0 0 0 1.23 8.31v5.475a2.456 2.456 0 0 0 2.449 2.449h9.34a2.456 2.456 0 0 0 2.448-2.45v-.357h-.935c-1.147 0-2.26-.839-2.365-2.077a2.244 2.244 0 0 1 .664-1.812 2.232 2.232 0 0 1 1.603-.667h1.034V8.31a2.456 2.456 0 0 0-2.45-2.45h-9.34ZM.009 8.31a3.676 3.676 0 0 1 3.67-3.67h9.34a3.676 3.676 0 0 1 3.669 3.67v1.171a.61.61 0 0 1-.61.61h-1.644c-.292 0-.549.114-.734.304l-.011.01a1.024 1.024 0 0 0-.307.832v.008c.044.516.54.961 1.15.961h1.546a.61.61 0 0 1 .61.61v.969a3.676 3.676 0 0 1-3.67 3.669h-9.34a3.676 3.676 0 0 1-3.668-3.67V8.312Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M10.057 2.16a.936.936 0 0 0-1.264-.878l-6.46 2.441A1.707 1.707 0 0 0 1.23 5.325v3.718a.61.61 0 1 1-1.22 0V5.325c0-1.22.75-2.311 1.891-2.743l6.46-2.44c1.409-.535 2.917.511 2.917 2.018v3.092a.61.61 0 1 1-1.22 0V2.16ZM14.434 10.092c-.293 0-.55.114-.735.304l-.01.011a1.024 1.024 0 0 0-.308.832l.001.007c.043.516.54.962 1.15.962h1.58a.225.225 0 0 0 .217-.22v-1.676a.225.225 0 0 0-.217-.22h-1.678ZM12.83 9.54a2.231 2.231 0 0 1 1.604-.667H16.146a1.445 1.445 0 0 1 1.402 1.44v1.676a1.446 1.446 0 0 1-1.423 1.44H14.53c-1.147 0-2.26-.839-2.365-2.077a2.244 2.244 0 0 1 .664-1.812Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M3.67 8.71a.61.61 0 0 1 .611-.61h5.695a.61.61 0 0 1 0 1.22H4.281a.61.61 0 0 1-.61-.61Z"
      clipRule="evenodd"
    />
  </svg>
)

const OrderIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={17} fill="none">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M4 5.491a2.3 2.3 0 0 0-2.293 2.295v5.129A2.3 2.3 0 0 0 4 15.209h8.75a2.3 2.3 0 0 0 2.294-2.294v-.335h-.877c-1.074 0-2.117-.786-2.215-1.947a2.102 2.102 0 0 1 .622-1.697 2.09 2.09 0 0 1 1.502-.625h.968v-.525A2.3 2.3 0 0 0 12.75 5.49H4ZM.564 7.786a3.444 3.444 0 0 1 3.438-3.438h8.75a3.444 3.444 0 0 1 3.437 3.438v1.097a.572.572 0 0 1-.572.572h-1.54a.947.947 0 0 0-.687.284l-.01.01a.96.96 0 0 0-.288.78v.006c.04.484.506.901 1.077.901h1.448c.316 0 .572.256.572.572v.907a3.444 3.444 0 0 1-3.437 3.437H4a3.444 3.444 0 0 1-3.438-3.437v-5.13Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M9.976 2.024A.877.877 0 0 0 8.792 1.2L2.74 3.488a1.6 1.6 0 0 0-1.033 1.5v3.484a.572.572 0 1 1-1.144 0V4.988c0-1.143.703-2.165 1.772-2.57L8.387.133a2.02 2.02 0 0 1 2.733 1.892V4.92a.572.572 0 0 1-1.144 0V2.024ZM14.076 9.455a.947.947 0 0 0-.688.284l-.01.01a.96.96 0 0 0-.288.78v.007c.041.484.506.9 1.077.9h1.481a.21.21 0 0 0 .204-.205V9.66a.21.21 0 0 0-.204-.206h-1.572Zm-1.502-.518a2.09 2.09 0 0 1 1.502-.625h1.605a1.354 1.354 0 0 1 1.314 1.349v1.57a1.354 1.354 0 0 1-1.334 1.349h-1.494c-1.074 0-2.117-.786-2.215-1.946a2.103 2.103 0 0 1 .622-1.697Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M3.993 8.159c0-.316.256-.572.572-.572H9.9a.572.572 0 1 1 0 1.144H4.565a.572.572 0 0 1-.572-.572Z"
      clipRule="evenodd"
    />
  </svg>
)

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      useCoins: false,
      name: '',
      phone: '',
      email: '',
      payment: props?.data?.yookassa_stat ? 'online' : 'card',
      coment: '',
      noCallForConfirmation: false,
      // Состояния для скрытия/показа блоков
      isRecipientOpen: true,
      isTimeOpen: true,
      isPaymentOpen: true,
      // Состояние для выбора времени доставки
      deliveryTimeType: 'asap', // 'asap' или 'schedule'
      selectedTime: '',
      selectedDate: '',
      // Модальное окно выбора времени
      isTimeModalVisible: false,
      // Доступное время для доставки
      availableTimes: []
    }
  }

  // Добавьте метод для сохранения в localStorage
  saveNoCallPreference = (checked) => {
    localStorage.setItem('noCallForConfirmation', checked ? 'true' : 'false')
  }

  // Добавьте метод для обработки изменения чекбокса:
  handleNoCallChange = (e) => {
    const checked = e.target.checked
    this.setState({ noCallForConfirmation: checked })
    this.saveNoCallPreference(checked)
  }

  // Функция для генерации доступного времени для конкретной даты
  generateTimesForDate = (date) => {
    const worktime = this.getWorktimeForDate(date);
    
    if (!worktime) return [];

    const times = [];
    const [start, end] = worktime.split('-').map(time => {
      const [hours, minutes] = time.split(':').map(Number);
      return hours * 60 + minutes;
    });

    // Если ресторан открывается, например, в 11:00, то заказать можно с 12:00 (на час позже)
    const startTime = start + 30;

    for (let time = startTime; time <= end; time += 15) {
      const hours = Math.floor(time / 60);
      const minutes = time % 60;
      const timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
      times.push(timeString);
    }

    return times;
  }

  componentDidMount() {
    const { user, data } = this.props

    // Загружаем сохраненное значение чекбокса
    const savedNoCallPreference = localStorage.getItem('noCallForConfirmation')
    const noCallForConfirmation = savedNoCallPreference === 'true'

    this.setState({
      name: user?.fullname || '',
      phone: user?.phone || '',
      email: user?.email || '',
      payment: data?.yookassa_stat ? 'online' : 'card',
      noCallForConfirmation: noCallForConfirmation // Загружаем сохраненное значение
    })
    
    //console.log('Restaurant custom_worktime:', restaurant?.custom_worktime);
    //console.log('Restaurant worktime:', restaurant?.worktime);
    
    // Проверяем работу функции для разных дней
    const testDates = [
      dayjs(), // сегодня
      dayjs().add(1, 'day'), // завтра
      dayjs().add(2, 'day'), // послезавтра
    ];
    
    testDates.forEach(date => {
      const worktime = this.getWorktimeForDate(date);
      //console.log(`Date: ${date.format('DD.MM.YYYY')}, Worktime: ${worktime}`);
    });
  }

  componentDidUpdate(prevProps) {

  }

  // Функция для расчета количества коинов
  calculateCoin = (totalPrice, rangOrderPercent, userCoins) => {
    if (!totalPrice || !rangOrderPercent) return 0
    
    const maxCoinAmount = Math.floor(totalPrice * (rangOrderPercent / 100))
    const availableCoins = userCoins || 0
    
    return Math.min(availableCoins, maxCoinAmount)
  }

  // Функция для переключения состояния использования коинов
  toggleCoinUsage = () => {
    this.setState(prevState => ({
      useCoins: !prevState.useCoins
    }))
  }

  // Функции для обработки изменений полей ввода
  handleInputChange = (field, value) => {
    this.setState({ [field]: value })
  }

  // Функция для обработки изменения телефона
  handlePhoneChange = (value) => {
    this.setState({ phone: value })
  }

  // Функции для переключения видимости блоков
  toggleRecipient = () => {
    this.setState(prevState => ({ isRecipientOpen: !prevState.isRecipientOpen }))
  }

  toggleTime = () => {
    this.setState(prevState => ({ isTimeOpen: !prevState.isTimeOpen }))
  }

  togglePayment = () => {
    this.setState(prevState => ({ isPaymentOpen: !prevState.isPaymentOpen }))
  }

  // Функция для выбора типа времени доставки
  handleDeliveryTimeTypeChange = (type) => {
    this.setState({ deliveryTimeType: type })
  }

  // Функция для выбора способа оплаты
  handlePaymentChange = (paymentType) => {
    this.setState({ payment: paymentType })
  }

  // Функции для работы с модальным окном времени
  showTimeModal = () => {
    this.setState({ isTimeModalVisible: true })
  }

  hideTimeModal = () => {
    this.setState({ isTimeModalVisible: false })
  }

  // Функция для получения доступных дат (7 дней вперед)
  getAvailableDates = () => {
    const dates = []
    const today = dayjs()

    const { data } = this.props
    
    for (let i = 0; i < data?.pre_order; i++) {
      const date = today.add(i, 'day')
      dates.push(date)
    }

    return dates
  }

  // Функция для проверки, является ли дата сегодняшним днем
  isToday = (date) => {
    try {
      if (typeof date === 'string') {
        // Разбираем строку формата DD.MM.YYYY
        const parts = date.split('.')
        if (parts.length === 3) {
          const day = parseInt(parts[0], 10)
          const month = parseInt(parts[1], 10) - 1 // month в dayjs от 0 до 11
          const year = parseInt(parts[2], 10)
          
          const dateToCheck = dayjs(new Date(year, month, day))
          return dateToCheck.isSame(dayjs(), 'day')
        }
      }

      return dayjs(date).isSame(dayjs(), 'day')
      
    } catch (error) {
      return true
    }
  }

  // Функция для форматирования даты
  formatDate = (date) => {
    const dayjsDate = dayjs(date)
    const today = dayjs()
    const tomorrow = today.add(1, 'day')
    
    if (dayjsDate.isSame(today, 'day')) {
      return 'Сегодня'
    } else if (dayjsDate.isSame(tomorrow, 'day')) {
      return 'Завтра'
    } else {
      return dayjsDate.format('DD.MM.YYYY')
    }
  }

  // Функция для форматирования даты
  formatDateS = (date) => {
    return dayjs(date).format('DD.MM.YYYY')
  }

  // Функция для выбора даты и времени
  handleDateSelect = (date) => {
    const formattedDate = this.formatDateS(date);
    this.setState({
      selectedDate: formattedDate,
      selectedTime: '' // Сбрасываем время при смене даты
    });
  }

  // Функция для выбора времени
  handleTimeSelect = (time) => {
    const { selectedDate } = this.state
    
    // Если дата не выбрана, используем сегодняшнюю дату
    let dateToUse = selectedDate
    if (!dateToUse) {
      dateToUse = this.formatDateS(dayjs())
      this.setState({ selectedDate: dateToUse })
    }
    
    this.setState({
      selectedTime: time,
      isTimeModalVisible: false
    })
  }

  // Функция для получения времени работы для конкретной даты
  getWorktimeForDate = (date) => {
    const { restaurant } = this.props;
    
    if (!restaurant?.custom_worktime && !restaurant?.worktime) return null;
    
    let dayjsDate;
    
    // Если date - это строка в формате DD.MM.YYYY
    if (typeof date === 'string' && date.includes('.')) {
      const parts = date.split('.');
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);
        dayjsDate = dayjs(new Date(year, month, day));
      } else {
        dayjsDate = dayjs();
      }
    } else {
      dayjsDate = dayjs(date);
    }
    
    // Получаем день недели (1-7, где 1 - понедельник, 7 - воскресенье)
    const dayOfWeek = dayjsDate.day() === 0 ? 7 : dayjsDate.day();
    
    //console.log('Date:', date, 'Parsed date:', dayjsDate.format('DD.MM.YYYY'), 'Day of week:', dayOfWeek, 'Worktime:', restaurant?.custom_worktime?.[dayOfWeek]);
    
    // Возвращаем время работы для этого дня или общее время работы
    return restaurant?.custom_worktime?.[dayOfWeek] || restaurant?.worktime;
  }

  // Функция для проверки, доступно ли время для выбранной даты
  isTimeAvailable = (time, date) => {
    const now = dayjs();
    
    // Если дата не передана, используем из state
    const dateToCheck = date || this.state.selectedDate || this.formatDateS(now);
    
    if (this.isToday(dateToCheck)) {
      const [hours, minutes] = time.split(':').map(Number);
      const selectedDateTime = now.hour(hours).minute(minutes).second(0);
      
      // Время должно быть как минимум на 1 час вперед от текущего времени
      return selectedDateTime.isAfter(now.add(1, 'hour'));
    }
    
    // Для будущих дат все времена доступны (они уже сгенерированы в пределах рабочего времени)
    return true;
  }

  // Функция для получения доступных времен для выбранной даты
  getAvailableTimesForSelectedDate = () => {
    const { selectedDate } = this.state;

    // Если дата не выбрана, используем сегодняшнюю дату
    const dateToUse = selectedDate || this.formatDateS(dayjs());
    
    //console.log('Getting times for date:', dateToUse);
    
    // Генерируем времена для выбранной даты
    const allTimes = this.generateTimesForDate(dateToUse);
    
    //console.log('Generated times:', allTimes);
    
    // Фильтруем доступные времена
    const availableTimes = allTimes.filter(time => this.isTimeAvailable(time, dateToUse));
    
    //console.log('Available times:', availableTimes);
    
    return availableTimes;
  }

  // Функция для проверки, открыт ли ресторан
  isRestaurantOpen = (restaurant) => {
    if (!restaurant?.custom_worktime && !restaurant?.worktime) return false;
    
    try {
      // Получаем текущий день недели (1-7, где 1 - понедельник, 7 - воскресенье)
      const currentDay = dayjs().day() === 0 ? 7 : dayjs().day()
      
      // Получаем время работы для текущего дня
      const worktime = restaurant?.custom_worktime?.[currentDay] || restaurant?.worktime
      
      if (!worktime) return false;
      
      // Парсим формат "11:00-22:30"
      const [openTimeStr, closeTimeStr] = worktime.split('-');
      if (!openTimeStr || !closeTimeStr) return false;
      
      // Получаем текущее время
      const now = new Date();
      const currentHours = now.getHours();
      const currentMinutes = now.getMinutes();
      const currentTotalMinutes = currentHours * 60 + currentMinutes;
      
      // Парсим время открытия
      const [openHours, openMinutes] = openTimeStr.split(':').map(Number);
      const openTotalMinutes = openHours * 60 + openMinutes;
      
      // Парсим время закрытия
      const [closeHours, closeMinutes] = closeTimeStr.split(':').map(Number);
      let closeTotalMinutes = closeHours * 60 + closeMinutes;
      
      // Если ресторан работает после полуночи (например, до 02:00)
      if (closeTotalMinutes < openTotalMinutes) {
        closeTotalMinutes += 24 * 60; // Добавляем сутки
      }
      
      // Проверяем, находится ли текущее время в промежутке работы
      return currentTotalMinutes >= openTotalMinutes && currentTotalMinutes <= closeTotalMinutes;
    } catch (error) {
      console.error('Ошибка при парсинге времени работы:', error, worktime);
      return false;
    }
  };

  render() {
    const { data, user, restaurant, cart, assets_path, showLocation, changeDeliveryType, showUsloviyaWin } = this.props
    const {
      useCoins,
      name,
      phone,
      email,
      payment,
      coment,
      isRecipientOpen,
      isTimeOpen,
      isPaymentOpen,
      deliveryTimeType,
      selectedTime,
      selectedDate,
      isTimeModalVisible
    } = this.state

    // Рассчитываем количество коинов для списания
    const coinsToDeduct = this.calculateCoin(
      cart?.total_price, 
      user?.rang_order_percent, 
      user?.coin
    )

    const total_delivery_price = user?.delivery_type == 'delivery' ? ( cart?.total_price >= user?.location?.sum_for_free ? 0 : ( user?.location?.delivery_price || 0 ) ) : 0

    // Получаем доступные даты
    const availableDates = this.getAvailableDates()

    const isOpen = this.isRestaurantOpen(restaurant)

    return (
      <div className='container bg-cover bg-center bg-no-repeat font-manrope tracking-tight h-dvh flex flex-col'
        style={{ backgroundImage: `url(/${assets_path}/images/cartbg.svg)` }}
      >
        <SimpleHeader
          title={`Оформление заказа`}
          user={user}
          lk_link={data?.lk_link}
        />
        <DeliveryType
          user={user}
          restaurant={restaurant}
          showLocation={showLocation}
          changeDeliveryType={changeDeliveryType}
          showUsloviyaWin={showUsloviyaWin}
        />

        {/* Блок получателя */}
        <div className='mt-[10px] bg-white rounded-[25px] p-[15px]'>
          <div className='flex items-start justify-between w-100 mb-[10px]'>
            <div>
              <div className='text-black text-[18px] font-semibold'>Получатель</div>
              <div className='text-[14px] text-[#00000099]'>{name}, {phone}</div>
            </div>
            <div 
              className='bg-[#F6F6F6] w-[30px] h-[30px] rounded-[15px] flex items-center justify-center cursor-pointer'
              onClick={this.toggleRecipient}
            >
              <Arrow isOpen={!isRecipientOpen} />
            </div>
          </div>
          
          {isRecipientOpen && (
            <>
              <div className="relative w-full mb-[5px]">
                <input 
                  className='w-[100%] px-[15px] py-[10px] text-[16px] bg-[#F6F6F6] rounded-[50px]' 
                  name='name' 
                  type='text' 
                  placeholder='Имя' 
                  value={name} 
                  onChange={(e) => this.handleInputChange('name', e.target.value)}
                />
                {name == `` &&
                  <span className="absolute left-[43px] top-1/2 transform -translate-y-1/2 text-red-500">*</span>
                }
              </div>
              <IMaskInput
                className='w-[100%] px-[15px] py-[10px] text-[16px] bg-[#F6F6F6] rounded-[50px] mb-[5px]'
                mask={"+7 000 000-00-00"}
                value={phone}
                onAccept={(value) => this.handlePhoneChange(value)}
                placeholder={"+7 000 000-00-00"}
              />
              {/* Чекбокс "Не звонить для подтверждения" */}
              <label className="flex items-center gap-2 mb-[5px] cursor-pointer">
                <input
                  type="checkbox"
                  checked={this.state.noCallForConfirmation}
                  onChange={this.handleNoCallChange}
                  className="w-4 h-4 rounded border-gray-300 text-[#5A91FF] focus:ring-[#5A91FF]"
                />
                <span className="text-[14px] text-black">Не звонить для подтверждения</span>
              </label>
              <input 
                className='w-[100%] px-[15px] py-[10px] text-[16px] bg-[#F6F6F6] rounded-[50px]' 
                name='email' 
                type='text' 
                placeholder='E-mail для чека' 
                value={email} 
                onChange={(e) => this.handleInputChange('email', e.target.value)}
              />
            </>
          )}
        </div>

        {/* Блок времени доставки */}
        <div className='mt-[10px] bg-white rounded-[25px] p-[15px]'>
          <div className='flex items-start justify-between w-100 mb-[10px]'>
            <div>
              <div className='text-black text-[18px] font-semibold'>Время доставки</div>
              <div className='text-[14px] text-[#00000099]'>
                На доставку с 11:00 до 22:30<br />
                На самовывоз с 11:00 до 23:00
              </div>
              <div className='mt-[10px] text-[14px] text-[#00000099]'>
                {deliveryTimeType === 'asap' 
                  ? 'Как можно скорее' 
                  : selectedDate && selectedTime 
                    ? `${selectedDate} в ${selectedTime}` 
                    : 'В любой момент'
                }
              </div>
            </div>
            <div 
              className='bg-[#F6F6F6] w-[30px] h-[30px] rounded-[15px] flex items-center justify-center cursor-pointer'
              onClick={this.toggleTime}
            >
              <Arrow isOpen={!isTimeOpen} />
            </div>
          </div>
          
          {isTimeOpen && (
            <div className='flex items-start gap-[5px]'>
              {/* Как можно скорее */}
              <div 
                className={`cursor-pointer rounded-[25px] p-[10px] flex-none ${
                  deliveryTimeType === 'asap' ? 'bg-[#5A91FF] text-white' : 'bg-[#F6F6F6] text-black'
                }`}
                onClick={() => this.handleDeliveryTimeTypeChange('asap')}
              >
                <div className='flex items-center gap-[7px] mb-[10px]'>
                  <div className={`w-[30px] h-[30px] rounded-[15px] flex items-center justify-center ${
                    deliveryTimeType === 'asap' ? 'bg-[#FFFFFF40]' : 'bg-[#EDEDED]'
                  }`}>
                    {deliveryTimeType === 'asap' && <CheckIcon />}
                  </div>
                </div>
                <div>
                  <div className='text-[18px] font-medium leading-none'>Как можно<br />скорее</div>
                  <div className={`text-[14px] ${
                    deliveryTimeType === 'asap' ? 'text-[#FFFFFF99]' : 'text-[#00000099]'
                  }`}>за 60-70 мин</div>
                </div>
              </div>

              {/* Ко времени */}
              <div 
                className={`cursor-pointer rounded-[25px] p-[10px] flex-1 ${
                  deliveryTimeType === 'schedule' ? 'bg-[#5A91FF] text-white' : 'bg-[#F6F6F6] text-black'
                }`}
                onClick={() => {
                  this.handleDeliveryTimeTypeChange('schedule')
                  this.showTimeModal()
                }}
              >
                <div className='flex items-center gap-[7px] mb-[10px]'>
                  <div className={`w-[30px] h-[30px] rounded-[15px] flex items-center justify-center ${
                    deliveryTimeType === 'schedule' ? 'bg-[#FFFFFF40]' : 'bg-[#EDEDED]'
                  }`}>
                    {deliveryTimeType === 'schedule' && <CheckIcon />}
                  </div>
                  <div>
                    <div className='text-[18px] font-medium'>Когда удобно</div>
                    <div className={`text-[14px] ${
                      deliveryTimeType === 'schedule' ? 'text-[#FFFFFF99]' : 'text-[#00000099]'
                    }`}>
                      {selectedDate && selectedTime ? `${selectedDate} в ${selectedTime}` : 'В любой момент'}
                    </div>
                  </div>
                </div>

                <div 
                  className='w-full bg-white rounded-[50px] h-[40px] flex items-center justify-between px-[15px] cursor-pointer border border-gray-200'
                >
                  <span className='text-[14px] text-gray-600'>
                    {selectedDate && selectedTime ? `${selectedDate} в ${selectedTime}` : 'Выберите время'}
                  </span>
                  <TimeIcon />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Блок оплаты */}
        <div className='mt-[10px] bg-white rounded-[25px] p-[15px]'>
          <div className='flex items-start justify-between w-100 mb-[10px]'>
            <div>
              <div className='text-black text-[18px] font-semibold'>Оплата</div>
              <div className='text-[14px] text-[#00000099]'>
                {payment === 'online' && 'Онлайн оплата'}
                {payment === 'card' && 'Картой'}
                {payment === 'cash' && 'Наличными'}
              </div>
            </div>
            <div 
              className='bg-[#F6F6F6] w-[30px] h-[30px] rounded-[15px] flex items-center justify-center cursor-pointer'
              onClick={this.togglePayment}
            >
              <Arrow isOpen={!isPaymentOpen} />
            </div>
          </div>
          
          {isPaymentOpen && (
            <div className='w-[calc(100%+15px)] overflow-x-auto gap-[5px] flex items-center'>
              {/* СБП 
              <div 
                className={`rounded-[25px] cursor-pointer flex items-center justify-center gap-[8px] flex-none h-[40px] px-[15px] ${
                  payment === 'sbp' ? 'bg-[#5A91FF] text-white' : 'bg-[#F6F6F6] text-black'
                }`}
                onClick={() => this.handlePaymentChange('sbp')}
              >
                <img src={`/${assets_path}/images/sbp.png`} width={20} height={20} alt="СБП" />
                <div>СБП</div>
              </div>
              */}
              
              {/* Онлайн */}
              {data?.yookassa_stat &&
                <div 
                  className={`rounded-[25px] cursor-pointer flex items-center justify-center gap-[8px] flex-none h-[40px] px-[15px] ${
                    payment === 'online' ? 'bg-[#5A91FF] text-white' : 'bg-[#F6F6F6] text-black'
                  }`}
                  onClick={() => this.handlePaymentChange('online')}
                >
                  <img src={`/${assets_path}/images/sbp.png`} width={20} height={20} alt="СБП" />
                  <div>Онлайн оплата</div>
                </div>
              }

              {/* Карта */}
              {user?.delivery_type == 'delivery' ? (
                <div 
                  className={`rounded-[25px] cursor-pointer flex items-center justify-center gap-[8px] flex-none h-[40px] px-[15px] ${
                    payment === 'card' ? 'bg-[#5A91FF] text-white' : 'bg-[#F6F6F6] text-black'
                  }`}
                  onClick={() => this.handlePaymentChange('card')}
                >
                  <CardIcon />
                  <div>Картой курьеру</div>
                </div>
              ) : (
                <div 
                  className={`rounded-[25px] cursor-pointer flex items-center justify-center gap-[8px] flex-none h-[40px] px-[15px] ${
                    payment === 'card' ? 'bg-[#5A91FF] text-white' : 'bg-[#F6F6F6] text-black'
                  }`}
                  onClick={() => this.handlePaymentChange('card')}
                >
                  <CardIcon />
                  <div>Картой</div>
                </div>
              )}

              {/* Наличные */}
              <div 
                className={`rounded-[25px] cursor-pointer flex items-center justify-center gap-[8px] flex-none h-[40px] px-[15px] ${
                  payment === 'cash' ? 'bg-[#5A91FF] text-white' : 'bg-[#F6F6F6] text-black'
                }`}
                onClick={() => this.handlePaymentChange('cash')}
              >
                <CashIcon />
                <div>Наличными</div>
              </div>
            </div>
          )}
        </div>

        {/* Комментарий */}
        <input 
          className='w-[100%] px-[15px] py-[10px] text-[16px] bg-white rounded-[50px] mt-[10px] mb-[20px]' 
          name='coment' 
          type='text' 
          placeholder='Комментарий к заказу' 
          value={coment} 
          onChange={(e) => this.handleInputChange('coment', e.target.value)}
        />

        {/* Итоговая информация */}
        <div className='bg-white rounded-t-[18px] w-[calc(100%+20px)] ml-[-10px] p-[15px] mt-auto'>
          {coinsToDeduct > 0 &&
            <div className='flex gap-[5px] items-center mb-[15px] justify-between'>
              <div className='text-[18px] text-black font-semibold flex items-center gap-[5px]'>
                Списать Оки-коины
              </div>
              <div className='text-[18px] text-black font-semibold flex items-center gap-[5px]'>
                {coinsToDeduct}
                <Coin />
                <div 
                  className={`w-[51px] h-[31px] rounded-[16px] p-[2px] flex items-center cursor-pointer ${
                    useCoins ? 'bg-[#A6DD2F] justify-end' : 'bg-[#F6F6F6] justify-start'
                  }`}
                  onClick={this.toggleCoinUsage}
                >
                  <div className='w-[27px] h-[27px] rounded-[14px] shadow-md bg-white' />
                </div>
              </div>
            </div>
          }
          
          {user?.delivery_type == 'delivery' && (
            <div className='flex gap-[5px] items-center mb-[5px]'>
              <div className='text-[14px] text-[#00000099] font-medium flex items-center gap-[5px]'>
                <div>Доставка</div>
                <div onClick={() => showUsloviyaWin()} className='cursor-pointer ml-1'>
                  <Arrow />
                </div>
              </div>
              <div className='flex-1 h-[0px] w-[100%]' style={{ borderTop: `1px #0000001a dashed` }} />
              <div className='text-[14px] text-[#00000099] font-medium'>
                {total_delivery_price} ₽
                {user?.location?.time != `` && <> за <span className='text-black'>{user?.location?.time} мин</span></>}
              </div>
            </div>
          )}
          
          <div className='flex gap-[5px] items-center mb-[15px]'>
            <div className='text-[18px] text-black font-semibold flex items-center gap-[5px]'>
              Итого
            </div>
            <div className='flex-1 h-[0px] w-[100%]' style={{ borderTop: `1px #0000001a dashed` }} />
            {useCoins ?
              <div className='text-[18px] text-black font-semibold text-end'>
                <span className="line-through">{cart?.total_price}</span>
                {' '}
                <span>{cart?.total_price - coinsToDeduct} ₽</span>
              </div>
            :
              <div className='text-[18px] text-black font-semibold text-end'>
                {cart?.total_price != cart?.total_discount_price ? (
                  <>
                    <span className="line-through">{cart?.total_price}</span>
                    {' '}
                    <span>{cart?.total_discount_price} ₽</span>
                  </>
                ) : (
                  <span>{cart?.total_discount_price} ₽</span>
                )}
              </div>
            }
          </div>
          
          {cart?.total_discount_price > 0 && isOpen &&
            <button
              className="w-full p-[5px] h-10 rounded-full text-[16px] font-inter bg-[#5A91FF] text-white flex items-center justify-between gap-2 border-0 cursor-pointer"
              onClick={() => {
                if (this.props.onOrderSubmit) {
                  // Формируем комментарий с учетом чекбокса
                  let finalComment = this.state.coment
                  if (this.state.noCallForConfirmation) {
                    finalComment = finalComment
                      ? `${finalComment} // Не звонить для подтверждения`
                      : 'Не звонить для подтверждения'
                  }

                  this.props.onOrderSubmit({
                    useCoins: this.state.useCoins,
                    coinsAmount: this.state.useCoins ? coinsToDeduct : 0,
                    deliveryTime: deliveryTimeType === 'asap' ? '' : `${selectedDate} ${selectedTime}`,
                    paymentMethod: payment,
                    recipient: {
                      name: this.state.name,
                      phone: this.state.phone,
                      email: this.state.email
                    },
                    comment: finalComment
                  })
                }
              }}
            >
              <div className='w-[30px] h-[30px] rounded-full bg-[#FFFFFF40] flex items-center justify-center'>
                <OrderIcon />
              </div>
              <div className='flex items-center gap-[8px]'>
                <div>Оформить заказ</div>
                <svg xmlns="http://www.w3.org/2000/svg" width={4} height={4} fill="none">
                  <circle cx={2} cy={2} r={2} fill="#fff" fillOpacity={0.5} />
                </svg>
                {useCoins ?
                  <div>{cart?.total_price + total_delivery_price - coinsToDeduct} ₽</div>
                :
                  <div>{cart?.total_discount_price + total_delivery_price} ₽</div>
                }
              </div>
              <div className='w-[30px] h-[30px]'></div>
            </button>
          }
          {cart?.total_discount_price > 0 && !isOpen &&
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 text-center mb-4">
              <div className="text-yellow-800 text-sm font-medium">
                На данный момент мы не работаем
              </div>
              <div className="text-yellow-600 text-xs mt-1">
                {restaurant?.custom_worktime ? 'Работаем по расписанию' : `Принимаем заказы ${restaurant?.worktime}`}
              </div>
            </div>
          }
        </div>

        {isTimeModalVisible && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="fixed inset-0 bg-black bg-opacity-50" onClick={this.hideTimeModal}></div>
            <div className="relative bg-white rounded-[25px] w-full max-w-lg max-h-[80vh] overflow-y-auto p-6 shadow-xl">
              <div className="flex items-center justify-between mb-4">
                <div className="text-[18px] font-semibold">Выберите время доставки</div>
                <button onClick={this.hideTimeModal} className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center border-0 cursor-pointer">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 13L13 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                    <path d="M13 13L1 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>
                </button>
              </div>
          <div className="time-selection-content">
            {/* Выбор даты */}
            <div className="date-selection mb-4">
              <div className="text-sm font-medium mb-2">Выберите дату:</div>
              <div className="flex overflow-x-auto gap-2 pb-2">
                {availableDates.map((date, index) => (
                  <div
                    key={index}
                    className={`flex-none rounded-[15px] px-2 py-1 text-center cursor-pointer border ${
                      selectedDate === this.formatDateS(date) 
                        ? 'bg-[#5A91FF] text-white border-[#5A91FF]' 
                        : 'bg-white text-gray-700 border-gray-300'
                    }`}
                    onClick={() => this.handleDateSelect(date)}
                  >
                    <div className="text-sm font-medium">
                      {this.formatDate(date)}
                    </div>
                    <div className="text-xs opacity-70">
                      {dayjs(date).format('dddd')}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Выбор времени */}
            <div className="time-selection">
              <div className="text-sm font-medium mb-2">
                Выберите время:
                {selectedDate && (
                  <span className="text-xs text-gray-500 ml-2">
                    (Время работы: {this.getWorktimeForDate(selectedDate)})
                  </span>
                )}
              </div>
              <div className="grid grid-cols-4 gap-2">
                {this.getAvailableTimesForSelectedDate().map((time, index) => (
                  <div
                    key={index}
                    className={`rounded-[15px] px-2 py-1 text-center cursor-pointer border ${
                      selectedTime === time 
                        ? 'bg-[#5A91FF] text-white border-[#5A91FF]' 
                        : 'bg-white text-gray-700 border-gray-300'
                    }`}
                    onClick={() => this.handleTimeSelect(time)}
                  >
                    <div className="text-sm font-medium">{time}</div>
                  </div>
                ))}
              </div>

              {/* Сообщение если нет доступных времен */}
              {this.getAvailableTimesForSelectedDate().length === 0 && (
                <div className="text-center text-gray-500 py-4">
                  На выбранную дату нет доступных времен доставки
                </div>
              )}
            </div>

            {/* Кнопка подтверждения */}
            <div className="mt-6">
              <button
                className="w-full rounded-full bg-[#5A91FF] text-white h-10 border-0 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={this.hideTimeModal}
                disabled={!selectedTime}
              >
                {selectedTime ? `Выбрать ${selectedDate} в ${selectedTime}` : 'Выбрать время'}
              </button>
            </div>
          </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

Main.propTypes = {
  assets_path: PropTypes.string,
  data: PropTypes.object,
  protocol: PropTypes.string,
  user: PropTypes.object,
  cart: PropTypes.object,
  restaurant: PropTypes.object,
  showLocation: PropTypes.func,
  changeDeliveryType: PropTypes.func,
  showUsloviyaWin: PropTypes.func,
  onOrderSubmit: PropTypes.func
}

export default Main